var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "black",
    fillOpacity: 0.09
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.49 11.25C12.49 11.94 11.935 12.5 11.25 12.5C10.565 12.5 10.01 11.94 10.01 11.25C10.01 10.56 10.565 10 11.25 10C11.935 10 12.49 10.56 12.49 11.25ZM12.5 13.5H10V21.5H12.5V13.5ZM16.491 13.5H14.007V21.5H16.492V17.3C16.492 14.965 19.506 14.774 19.506 17.3V21.5H22V16.434C22 12.494 17.539 12.638 16.491 14.578V13.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7cb5fd8e4ebe872099bdf2771cef66f0.svg";
export { ForwardRef as ReactComponent };